import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import store from "./store/store.js";

const viewRoot = "./views";
const compRoot = "./components";

Vue.use(Router);

const router = new Router({
  history: true,
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },

    {
      path: "/admin",
      component: () => import(/* webpackChunkName: "Admin" */ `${compRoot}/Admin.vue`),
      beforeEnter: (to, from, next) => {
        if (!store.state.session.isAuthenticated) next({ name: "login", params: { dest: to } });
        else next();
      },
      children: [
        {
          path: "players",
          name: "admin-players",
          component: () =>
            import(/* webpackChunkName: "AdminPlayers" */ `${viewRoot}/admin/Players.vue`),
        },
        {
          path: "worlds",
          name: "admin-worlds",
          component: () =>
            import(/* webpackChunkName: "AdminWorlds" */ `${viewRoot}/admin/Worlds.vue`),
        },
        {
          path: "quests",
          name: "admin-quests",
          component: () =>
            import(/* webpackChunkName: "AdminQuests" */ `${viewRoot}/admin/Quests.vue`),
        },
        {
          path: "quest-efforts",
          name: "admin-quest-efforts",
          component: () =>
            import(
              /* webpackChunkName: "AdminQuestEfforts" */ `${viewRoot}/admin/QuestEfforts.vue`
            ),
        },
        {
          path: "quest-ranks",
          name: "admin-quest-ranks",
          component: () =>
            import(/* webpackChunkName: "AdminQuestRanks" */ `${viewRoot}/admin/QuestRanks.vue`),
        },
        {
          path: "rides",
          name: "admin-rides",
          component: () =>
            import(/* webpackChunkName: "AdminRides" */ `${viewRoot}/admin/Rides.vue`),
        },
      ],
    },
    {
      path: "/game",
      component: () => import(/* webpackChunkName: "Admin" */ `${compRoot}/Game.vue`),
      beforeEnter: (to, from, next) => {
        if (!store.state.session.isAuthenticated) next({ name: "login", params: { dest: to } });
        else next();
      },
      children: [
        {
          path: "/quest/:id",
          name: "quest",
          props: true,
          component: () =>
            import(/* webpackChunkName: "QuestLeaderboard" */ `${viewRoot}/QuestLeaderboard.vue`),
        },
        {
          path: "/player/:id",
          name: "player",
          props: true,
          component: () =>
            import(/* webpackChunkName: "PlayerProfile" */ `${viewRoot}/PlayerProfile.vue`),
        },
        {
          path: "/world/:id",
          name: "world",
          props: true,
          component: () => import(/* webpackChunkName: "World" */ `${viewRoot}/World.vue`),
        },
        {
          path: "/ride/:id",
          name: "rideDetails",
          props: true,
          component: () =>
            import(/* webpackChunkName: "RideDetails" */ `${viewRoot}/RideDetails.vue`),
        },
        {
          path: "/players",
          name: "players",
          component: () =>
            import(/* webpackChunkName: "PlayerLeaderboard" */ `${viewRoot}/PlayerLeaderboard.vue`),
        },
        {
          path: "/settings",
          name: "playerSettings",
          component: () =>
            import(/* webpackChunkName: "PlayerSettings" */ `${viewRoot}/PlayerSettings.vue`),
        },
        {
          path: "/strava-auth",
          name: "stravaAuth",
          component: () =>
            import(/* webpackChunkName: "StravaAuth" */ `${viewRoot}/StravaAuth.vue`),
        },
      ],
    },
    {
      path: "/login",
      name: "login",
      props: true,
      component: () => import(/* webpackChunkName: "Login" */ `${viewRoot}/Login.vue`),
    },
    {
      path: "*",
      component: () => import(/* webpackChunkName: "NotFound" */ `${viewRoot}/NotFound.vue`),
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) document.title = to.meta.title;
  next();
});

export default router;